import { Categories } from '@/entities/product/ui/categories';
import { CategoryT } from '@/entities/product/ui/categories/types';
import './product-detail.scss';

type Props = {
    categories?: CategoryT[];
};
export const ProductDetailAddonsCategories = ({ categories }: Props) => {
    if (!categories || !categories.length) {
        return null;
    }
    return <Categories />;
};
